import { useLanguage } from "@/contexts/LanguageContext";
import { useSiteContent, pickLocalized } from "@/contexts/SiteContentContext";
import { Shield, MapPin, Headphones, Satellite } from "lucide-react";

const BADGE_ICONS = [Shield, MapPin, Headphones, Satellite];

const TrustBadges = () => {
  const { locale } = useLanguage();
  const { content } = useSiteContent();
  const trust = content?.trust || {};
  const badges = trust.badges || [];
  const kpis = trust.kpis || [];
  const headline = pickLocalized(trust.headline, locale, "");

  return (
    <section data-testid="trust-section" className="container-px mx-auto max-w-7xl pt-20 lg:pt-28">
      {headline && (
        <p className="text-xs uppercase tracking-[0.22em] text-sky-700 font-medium">{headline}</p>
      )}

      {badges.length > 0 && (
        <div className="mt-8 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-3">
          {badges.map((b, i) => {
            const Icon = BADGE_ICONS[i % BADGE_ICONS.length];
            return (
              <div
                key={i}
                data-testid={`trust-badge-${i}`}
                className="flex items-center gap-3 rounded-2xl border border-neutral-200 bg-white px-4 py-3.5 hover:shadow-md transition-shadow"
              >
                <div className="w-10 h-10 rounded-xl bg-neutral-950 text-white grid place-items-center shrink-0">
                  <Icon className="w-4 h-4" />
                </div>
                <div className="text-sm font-medium text-neutral-900 break-words">
                  {pickLocalized(b.label, locale)}
                </div>
              </div>
            );
          })}
        </div>
      )}

      {kpis.length > 0 && (
        <div className="mt-10 grid grid-cols-3 gap-2 sm:gap-4">
          {kpis.map((k, i) => (
            <div
              key={i}
              data-testid={`trust-kpi-${i}`}
              className="rounded-2xl sm:rounded-3xl bg-neutral-950 text-white px-3 py-5 sm:px-6 sm:py-7 lg:px-8 lg:py-9 overflow-hidden"
            >
              <div className="font-display text-xl sm:text-3xl lg:text-5xl font-light tracking-tighter break-words">
                {k.value}
              </div>
              <div className="mt-1 text-[10px] sm:text-xs uppercase tracking-[0.15em] sm:tracking-[0.2em] text-neutral-400 break-words">
                {pickLocalized(k.label, locale)}
              </div>
            </div>
          ))}
        </div>
      )}
    </section>
  );
};

export default TrustBadges;
